// cards
export const testCard = document.getElementById("test-card") as HTMLDivElement;
export const resultsCard = document.getElementById("results-card") as HTMLDivElement;
export const optionsCard = document.getElementById("options-card") as HTMLDivElement;

// test
export const testText = document.getElementById("test-text") as HTMLParagraphElement;
export const testInput = document.getElementById("test-input") as HTMLInputElement;
export const testInputContainer = document.getElementById("test-input-container") as HTMLDivElement;
export const testTimerText = document.getElementById("test-timer-text") as HTMLSpanElement;
export const currentWordIndicator = document.getElementById(
  "current-word-indicator"
) as HTMLDivElement;

// results
export const wpmText = document.getElementById("wpm-text") as HTMLSpanElement;
export const testTypeText = document.getElementById("test-type-text") as HTMLSpanElement;
export const wordsText = document.getElementById("words-text") as HTMLSpanElement;
export const charsText = document.getElementById("chars-text") as HTMLSpanElement;
export const timeText = document.getElementById("time-text") as HTMLSpanElement;

// options
export const optionsTestTypeWordsButton = document.getElementById(
  "options-test-type-words-button"
) as HTMLButtonElement;

export const optionsWords10Button = document.getElementById(
  "options-words-10-button"
) as HTMLButtonElement;
export const optionsWords25Button = document.getElementById(
  "options-words-25-button"
) as HTMLButtonElement;
export const optionsWords50Button = document.getElementById(
  "options-words-50-button"
) as HTMLButtonElement;
export const optionsWords100Button = document.getElementById(
  "options-words-100-button"
) as HTMLButtonElement;
export const optionsWords200Button = document.getElementById(
  "options-words-200-button"
) as HTMLButtonElement;

export const optionsCurrentWordIndicatorAnimationsOnButton = document.getElementById(
  "options-current-word-indicator-animations-on-button"
) as HTMLButtonElement;
export const optionsCurrentWordIndicatorAnimationsOffButton = document.getElementById(
  "options-current-word-indicator-animations-off-button"
) as HTMLButtonElement;

// buttons
export const restartTestButton = document.getElementById(
  "restart-test-button"
) as HTMLButtonElement;
export const optionsButton = document.getElementById("options-button") as HTMLButtonElement;
export const optionsDoneButton = document.getElementById(
  "options-done-button"
) as HTMLButtonElement;
